import { Modal, Form, IFormContext } from 'rewire-ui';
import { GroupInsertInput }          from '../DataTypes';
import DataMutations                 from '../graphql/Mutations';
import mainPageModel                 from '../main-navigation/MainPageModel';
import { notifications }             from '../ui/Notifications';

export interface IAddGroupDialogData {
  areaId:   string;
  areaName: string;
}

export class AddGroupDialogModel extends Modal {
  form:    Form;
  areaId?: string;

  constructor() {
    super('Add Group');
    this.form = Form.create((form: IFormContext) => ({
      areaName:  form.static().label('Area'),
      groupName: form.string().label('Group Name').validators('required').placeholder('enter group name').autoFocus(),
    }));
    this.action('cancel')
        .action('save', this.submit, { variant: 'contained', type: 'submit' });
  }

  reset() {
    this.form.reset();
    this.areaId = undefined;
  }

  load(data: IAddGroupDialogData) {
    this.reset();
    this.areaId     = data.areaId;
    this.form.value = {areaName: data.areaName};
    this.open();
  }

  private save = async (): Promise<boolean> => {
    const groupInput: GroupInsertInput = {
      name:     this.form.field.groupName.value,
      areaId:   this.areaId,
      position: 0, // some value??
    };

    const result = await DataMutations.insertGroups('', [groupInput]);
    if (result?.[0]) {
      notifications.success('Group Created');
      mainPageModel.updateAreasAndGroups();
      return true;
    }

    notifications.error('Group Creation Failed');
    return false;
  };

  submit = async () => {
    return await this.form.submitAsync(this.save);
  };
}

const addGroupDialogModel = new AddGroupDialogModel();
export default addGroupDialogModel;
